import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import Label, { useLabels } from "components/general/Label"
import { completeRsc, getLevelRSC, getLongEventRSC } from 'helpers/rsc';
import { useGetPath, useGetURL, useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { Container, Dropdown, Nav, Navbar } from 'react-bootstrap';
import { ALL_URL, GetNocMedalAndParticipant, TYPE_DATA, isSwitchHost, sortDataByField, useGetFunctionOCSUrl } from 'helpers/utils';
import { useGetConfigSports, useGetDisciplines, useGetEvents, useGetEventUnits } from 'helpers/commonCodes';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { ItemDiscipline } from '../selectors/selector-discipline/selectorDisciplineMenu';
import { MainContainerContext } from './MainContainer';
import { useGetPhasesRibbon } from './ribbon-h2h/PhaseRibbonH2H';

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import useViewport from 'components/general/useViewPort';



const Sliders = () => {
  const params = useUrlFriendlyToParameters();
  let paramsURL = { ...params }
  let obj = useGetPath()
  const getUrl = useGetURL()
  const { singlePhase } = useGetPhasesRibbon()
  let objUrl = obj(paramsURL.mirs_language);
  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs"


  //Change object if make changes over params make changes in componets related   (Change URL object)
  paramsURL.mirs_rsc = getLongEventRSC(paramsURL.mirs_rsc)
  const dataConfigSport = useGetConfigSports(paramsURL);
  const isH2H = dataConfigSport?.isH2H
  const hasPool = dataConfigSport?.hasPool
  const hasTodayMatches = dataConfigSport?.hasTodayMatches
  const showCompetitionStatus = dataConfigSport?.showCompetitionStatus
  const getOCSURL = useGetFunctionOCSUrl()

  let hasBracket = dataConfigSport?.hasBracket ? dataConfigSport?.hasBracket : isH2H ? true : false
  let hasRanking = dataConfigSport && dataConfigSport.hasOwnProperty("hasRanking") ? dataConfigSport?.hasRanking : isH2H ? true : false
  let hasRecords = process.env.REACT_APP_RECORDS_ARRAY.includes(paramsURL.mirs_discipline)
  const hasResults = getLevelRSC(paramsURL.mirs_event) === "EVENT" || getLevelRSC(paramsURL.mirs_event) === "PHASE" || getLevelRSC(paramsURL.mirs_event) === "UNIT"

  const rscCheck = completeRsc(paramsURL.mirs_event) || paramsURL.mirs_rsc

  if (dataConfigSport && dataConfigSport.hasOwnProperty("exceptionRanking") && dataConfigSport?.exceptionRanking.includes(rscCheck)) {
    hasRanking = false;
  }
  if (dataConfigSport && dataConfigSport.hasOwnProperty("exceptionBracket") && dataConfigSport?.exceptionBracket.includes(rscCheck)) {
    hasBracket = false;
  }

  if (dataConfigSport && dataConfigSport.hasOwnProperty("exceptionRecord") && dataConfigSport?.exceptionRecord.includes(rscCheck)) {
    hasRecords = false;
  }

  let urlMultiMedallists = getUrl(paramsURL, 'multimedallists')
  let urlMedallists = getUrl(paramsURL, 'medallists')
  let urlMedal = getUrl(paramsURL, 'medal')
  urlMedal = getOCSURL(urlMedal, 'medal', paramsURL) // checking OCS URL
  let urlTeams = getUrl(paramsURL, 'teams')
  let urlCoaches = getUrl(paramsURL, 'coaches')
  let urlTechnicalOfficials = getUrl(paramsURL, 'technicalofficials')
  let urlHorses = getUrl(paramsURL, 'horses')
  let urlNocList = getUrl(paramsURL, 'noclist')
  let urlEntriesByDiscipline = getUrl(paramsURL, 'entriesbydiscipline')
  let urlScheduleByNoc = getUrl(paramsURL, 'schedulebynoc')
  urlScheduleByNoc = getOCSURL(urlScheduleByNoc, 'schedulebynoc', paramsURL) // checking OCS URL
  let urlEntriesByNoc = getUrl(paramsURL, 'entriesbynoc')
  let urlAthletesByNoc = getUrl(paramsURL, 'athletesbynoc')
  let urlMedallistsByNoc = getUrl(paramsURL, 'medallistsbynoc')
  urlMedallistsByNoc = getOCSURL(urlMedallistsByNoc, 'medallistsbynoc', paramsURL) // checking OCS URL
  let urlProfileByNoc = getUrl(paramsURL, 'profilebynoc')
  let out

  const handleClick = (e, urlDestination) => {
    if (isSwitchHost()) {
      e.preventDefault()
      window.location.href = urlDestination
    }
  }



  const eventInUrl = isSchOrRec({ urlData: objUrl.url }) && paramsURL.mirs_event && paramsURL.mirs_event !== ALL_URL.ALL_EVENT;
  const showRanking = objUrl.url.isResult || objUrl.url.isPool || objUrl.url.isBracket || objUrl.url.isRanking || eventInUrl
  //const showResult = !objUrl.url.isPool && !objUrl.url.isBracket && !objUrl.url.isRanking && !objUrl.url.isRecords;
  const showResult = objUrl.url.isResult;
  let isNocMedalAndParticipant = GetNocMedalAndParticipant({ ...params });
  if (objUrl.url.isCompetitionSchedule) {
    out = <>
      <div id="activity-list-link" className="d-none navbar-nav swiperSlide" role="listitem"><a className="nav-link" href="#"><Label data={'LabelActivityList'} /></a></div>
      <div id="non-competition-schedule-link" className="d-none navbar-nav swiperSlide" role="listitem"><a className=" nav-link" href="#"><Label data={'LabelNonCompetitionSchedule'} /></a></div>
    </>
  } else if ((objUrl.url.isResult ||
    objUrl.url.isEntries ||
    objUrl.url.isPool ||
    objUrl.url.isBracket ||
    objUrl.url.isRecords ||
    objUrl.url.isRanking)
    && paramsURL.mirs_discipline
    && paramsURL.mirs_discipline !== ALL_URL.ALL_DISC) {

    /* RESULTS*/
    out = <>
      <ElementMenuSchedule paramsURL={paramsURL} label={'Schedule'} />
      <ElementMenuEvents />
      {hasResults && showResult && <ElementMenuResults paramsURL={paramsURL} active={objUrl.url.isResult} />}
      {hasTodayMatches && !isMobile && <ElementMenuTodayMatches paramsURL={paramsURL} />}
      <ElementMenuEntries paramsURL={paramsURL} />
      {isH2H && hasPool && <ElementMenuGroups active={objUrl.url.isPool} />}
      {hasBracket && <ElementMenuBrackets active={objUrl.url.isBracket} />}
      {hasRanking && showRanking && <ElementMenuRanking paramsURL={paramsURL} />}
      <ElementMenuReports paramsURL={paramsURL} />
      {hasRecords && <ElementMenuRecords paramsURL={paramsURL} />}
      {showCompetitionStatus && <ElementCompetitionStatus paramsURL={paramsURL} />}

    </>

  } else if (objUrl.url.isEntries && paramsURL.mirs_discipline && paramsURL.mirs_discipline !== ALL_URL.ALL_DISC) {
    /* ENTRIES NO DISCIPLINE*/
    out = <>
      <ElementMenuEntries paramsURL={paramsURL} />
      <ElementMenuReports paramsURL={paramsURL} />
      {hasRecords && <ElementMenuRecords paramsURL={paramsURL} />}
    </>
  } else if (
    (objUrl.url.isSchedule || objUrl.url.isCompetitionStatus || objUrl.url.isHearingSchedule || objUrl.url.isReports ||
      objUrl.url.isTodayAthMatches || objUrl.url.isTodayMatches || objUrl.url.isTodayTeamMatches) &&
    paramsURL.mirs_discipline && paramsURL.mirs_discipline !== ALL_URL.ALL_DISC
  ) {
    /**  SCHEDULES*/
    out = <>
      <ElementMenuSchedule paramsURL={paramsURL} label={'Schedule'} />
      {hasTodayMatches && !isMobile && <ElementMenuTodayMatches paramsURL={paramsURL} />}
      <ElementMenuEvents />
      <ElementMenuEntries paramsURL={paramsURL} />
      {isH2H && hasPool && <ElementMenuGroups />}
      {hasBracket && <ElementMenuBrackets />}
      {hasRanking && showRanking && <ElementMenuRanking paramsURL={paramsURL} />}
      <ElementMenuReports paramsURL={paramsURL} />
      {hasRecords && <ElementMenuRecords paramsURL={paramsURL} />}
      {showCompetitionStatus && <ElementCompetitionStatus paramsURL={paramsURL} />}
    </>
  } else if (objUrl.url.isMedal || objUrl.url.isMedallists || objUrl.url.isMultiMedallists) {
    /**  MEDALIST*/
    out = <>
      <Nav.Link as={CustomLink} id="OCSMenuMedalStandings" to={urlMedal} onClick={(e) => handleClick(e, urlMedal)} ><Label data={'MedalStandings'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuMedallists" to={urlMedallists}><Label data={'LabelMedallists'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuMultiMedallists" to={urlMultiMedallists}><Label data={'MultiMedallists'} /></Nav.Link>
    </>
  } else if (objUrl.url.isAthletes || objUrl.url.isTeams || objUrl.url.isCoaches || objUrl.url.isTechnicalOfficials || objUrl.url.isHorses || objUrl.url.isNocList || objUrl.url.isEntriesDiscipline) {
    /** CATEGORIES */
    out = <>
      <ElementMenuAthletes paramsURL={paramsURL} label={'LabelAthletes'} active={objUrl.url.isAthletes} />
      <Nav.Link as={CustomLink} id="OCSMenuTeams" to={urlTeams} active={objUrl.url.isTeams}><Label data={'Teams'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuCoaches" to={urlCoaches} active={objUrl.url.isCoaches}><Label data={'Coaches'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuOfficials" to={urlTechnicalOfficials} active={objUrl.url.isTechnicalOfficials}><Label data={'TechnicalOfficials'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuHorses" to={urlHorses} active={objUrl.url.isHorses}><Label data={'Horses'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuNocList" to={urlNocList} active={objUrl.url.isNocList}><Label data={'LabelNocs'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuEntriesDiscipline" to={urlEntriesByDiscipline} active={objUrl.url.isEntriesDiscipline}><Label data={'LabelEntriesDiscipline'} /></Nav.Link>
    </>
  } else if (objUrl.url.isScheduleByNoc || objUrl.url.isEntriesByNoc || objUrl.url.isMedallistsByNoc || objUrl.url.isProfileByNoc || objUrl.url.isAthletesByNoc) {
    /* NOCS*/
    out = <>
      <Nav.Link as={CustomLink} id="OCSMenuScheduleByNoc" to={urlScheduleByNoc}><Label data={'LabelSchedule'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuEntriesByNoc" to={urlEntriesByNoc}><Label data={'LabelEntries'} /></Nav.Link>
      <Nav.Link as={CustomLink} id="OCSMenuMedallistByNoc" to={urlMedallistsByNoc} onClick={(e) => handleClick(e, urlMedallistsByNoc)}><Label data={'NocMedallists'} /></Nav.Link>
      {/* <Nav.Link as={CustomLink} id="OCSMenuProfileByNoc" to={urlProfileByNoc}><Label data={'LabelProfile'} /></Nav.Link> */}
      {isNocMedalAndParticipant && <Nav.Link as={CustomLink} id="OCSMenuProfileByNoc" to={urlProfileByNoc}><Label data={'LabelProfile'} /></Nav.Link>}
      <Nav.Link as={CustomLink} id="OCSMenuAthleteByNoc" to={urlAthletesByNoc}><Label data={'LabelAthletes'} /></Nav.Link>
    </>
  }

  return (out)
}


export const NavBarSecondaryScroll = () => {
  const swiperRef = useRef(null);

  useLayoutEffect(() => {
    const swiperEl = document.querySelector('.swiper-menu');
    if (swiperEl) {
      swiperEl.setAttribute("role", "list")
    }
  }, [])

  return (
    <div id='extNavigation'>

      <Navbar id="mirs-second-navigation-bar" aria-labelledby='NavBarSecondaryScroll'>
        <span id="NavBarSecondaryScroll" className="d-none"><Label data={'LabelSportsNav'} /></span>
        <Container>
          <Swiper
            observer={'true'} //Recalcule cuando los sliders cambien , numero de sliders y se recalcule el ancho 
            ref={swiperRef}
            slidesPerView={"auto"}
            initialSlide={1}
            spaceBetween={0}
            freeMode={true}
            simulateTouch={true}
            modules={[FreeMode]}
            className='navbar-group'
            wrapperClass="swiper-wrapper swiper-menu"

          >
            <Sliders />
          </Swiper>
        </Container>
      </Navbar>
    </div>
  )
}
//Workaround in order to put UnitList inside wraper Slider
Sliders.displayName = 'SwiperSlide'



export default NavBarSecondaryScroll







/*Funciones*/
const isSchOrRec = ({ urlData }) => {
  let out = false
  if (urlData.isSchedule) {
    out = true
  } else if (urlData.isRecords) {
    out = true
  }
  return out
}




/*ELEMENTOS MENU*/

function ElementMenuEvents() {
  const params = useUrlFriendlyToParameters();
  const [isSport, setIsSport] = useState(false);
  const [show, setShow] = useState(false);
  //const [element, setElement] = useState("");
  const dataDiscipline = useGetDisciplines(params);
  const discipline = dataDiscipline?.disciplines?.find(item => item.code === params.mirs_discipline)?.description
  const sports = dataDiscipline?.disciplines?.filter(item => item?.isSport && item?.scheduled);
  const fLabel = useLabels();
  sortDataByField(sports, "description", true, TYPE_DATA.STRING);

  const handleOnSelect = (key => {
    if (key === 'sports') {
      setIsSport(true)
    } else {
      setShow(false);
    }
  })
  return (
    <>
      <SwiperSlide className="swiperSlide" role="listitem">
        <Dropdown
          show={show}
          onToggle={(nextShow, meta) => {
            if (meta?.source !== "select") {
              setShow(nextShow);
              setIsSport(false)
            }
          }}
          onSelect={handleOnSelect}
          id="OCSMenuEvents" className={"selectorContainer"} >
          <Dropdown.Toggle><Label data="HeaderEvents" /></Dropdown.Toggle>
          <Dropdown.Menu role="list" title={fLabel({ data: 'HeaderEvents' })} >
            {isSport ? (
              <SportsItems data={sports} page={"schedule"} />
            ) :
              <EventsItems discipline={discipline} page={"schedule"} />
            }
          </Dropdown.Menu>
        </Dropdown >
      </SwiperSlide>
    </>
  )
}

//fix sports with link problems in result button
function workAroundForSpecificSport({ eventUnit, event }) {
  const problemSportEvent = ["EQUOEVEN--------------", "EQUODRES--------------"] //put sport event that needs scheduled === S
  if (problemSportEvent?.includes(event)) {
    return eventUnit?.scheduled === "S"
  } else {
    return false
  }
}

function ElementMenuResults({ active, paramsURL }) {
  const { mirs_event } = paramsURL
  const { expandedComponent, resultBtn } = React.useContext(MainContainerContext);
  const { open, setOpen } = expandedComponent;
  // const { showBtnResults, setShowBtnResults } = resultBtn;
  const data = useGetEventUnits(paramsURL)
  const unitsList = data?.eventUnits?.filter(p => (p.scheduled === "Y" || workAroundForSpecificSport({ eventUnit: p, event: mirs_event })) && p.phase?.type === "3" && p.code?.startsWith(mirs_event)) || []
  // const phasesObj = eventObj?.filter(x => x.code?.startsWith(mirs_event))
  const singleUnit = unitsList.length > 1 ? false : true
  const firstUnitInPhase = unitsList?.find(x => x !== undefined) || {}

  const getUrl = useGetURL()

  paramsURL["mirs_rsc"] = firstUnitInPhase?.code || ''
  const urlSingleUnit = getUrl(paramsURL, 'results')

  const handleClick = () => {
    setOpen(!open);
  }

  return (
    <>
      {resultBtn && singleUnit
        ?
        <Nav.Link id="OCSMenuResults" role="" as={CustomLink} to={urlSingleUnit}><Label data={'ResultsSort'} /></Nav.Link>
        :
        <SwiperSlide className="swiperSlide" role="listitem">
          <div id="OCSMenuResults" role="" className={`selectorContainer dropdown ${active ? "active" : ""} `}  >
            <button type="button" onClick={(e) => handleClick()} aria-expanded={open} className="dropdown-toggle btn btn-primary"><Label data={'ResultsSort'} /> </button>
          </div>
        </SwiperSlide>
      }
    </>
  )
}

function ElementMenuTodayMatches({ paramsURL }) {
  const { mirs_event, mirs_language } = paramsURL
  const isJudIndiv = /JUD.*/.test(mirs_event) && !/JUD.TEAM.*/.test(mirs_event)
  let obj = useGetPath()
  let objUrl = obj(mirs_language)

  const label = objUrl?.url?.isTodayAthMatches || isJudIndiv ? 'LabelTodayContests' : 'LabelTodayMatches'
  const type = objUrl?.url?.isTodayAthMatches || isJudIndiv ? 'todayathmatches' : 'todaymatches'

  const getUrl = useGetURL()
  const urlTodayMatches = getUrl(paramsURL, type)

  let out = <><Nav.Link id="OCSMenuTodayMatches" as={CustomLink} to={urlTodayMatches}><Label data={label} /></Nav.Link></>

  return out;
}

function ElementCompetitionStatus({ paramsURL }) {
  const getUrl = useGetURL()
  const urlCompetitionStatus = getUrl(paramsURL, 'competitionstatus')
  const urlHearingSchedule = getUrl(paramsURL, 'hearingschedule')
  const out = (<>
    <Nav.Link id="OCSMenuCompetitionStatus" as={CustomLink} to={urlCompetitionStatus}><Label data={'LabelCompetitionStatus'} /></Nav.Link>
    <Nav.Link id="OCSMenuHearingSchedule" as={CustomLink} to={urlHearingSchedule}><Label data={'LabelHearingSchedule'} /></Nav.Link>
  </>)

  return out;
}

function ElementMenuRanking({ paramsURL }) {
  const getUrl = useGetURL()
  let urlRanking = getUrl(paramsURL, 'ranking')
  return (
    <Nav.Link id="OCSMenuRanking" as={CustomLink} to={urlRanking} > <Label data={'LabelRanking'} /></Nav.Link>
  )

}

function ElementMenuEntries({ paramsURL }) {
  const getUrl = useGetURL()
  //to fix the EQU event mix between indv and team
  if (paramsURL.mirs_event === "EQUOEVEN--------------") { paramsURL.mirs_event = "EQUOEVENINDV----------" }
  if (paramsURL.mirs_event === "EQUODRES--------------") { paramsURL.mirs_event = "EQUODRESINDV----------" }
  const urlEntries = getUrl(paramsURL, 'entries')
  return (
    <Nav.Link id="OCSMenuEntries" as={CustomLink} to={urlEntries}><Label data={'MenuEntries'} /></Nav.Link>
  )
}

function ElementMenuReports({ paramsURL }) {
  const getUrl = useGetURL()
  let urlReports = getUrl(paramsURL, 'reports')
  return (
    <Nav.Link id="OCSMenuReports" as={CustomLink} to={urlReports}><Label data={'Reports'} /></Nav.Link>
  )
}

function ElementMenuRecords({ paramsURL }) {
  const getUrl = useGetURL()
  let urlRecords = getUrl(paramsURL, 'records')
  return (
    <Nav.Link id="OCSMenuRecords" as={CustomLink} to={urlRecords}><Label data={'LabelRecords'} /></Nav.Link>
  )
}

function ElementMenuSchedule({ paramsURL, label }) {
  const handleClick = (e, urlSchedule) => {
    if (isSwitchHost()) {
      e.preventDefault()
      window.location.href = urlSchedule
    }
  }
  const getUrl = useGetURL()
  paramsURL["mirs_date"] = ''
  let urlSchedule = getUrl(paramsURL, 'schedule')
  const getOCSURL = useGetFunctionOCSUrl()
  urlSchedule = getOCSURL(urlSchedule, 'schedule', paramsURL)
  return (
    <Nav.Link id="OCSMenuSchedule" as={CustomLink} to={urlSchedule} onClick={(e) => handleClick(e, urlSchedule)} ><Label data={label} /></Nav.Link>
  )

}

function ElementMenuAthletes({ paramsURL, label }) {
  const getUrl = useGetURL()
  let urlAthletes = getUrl(paramsURL, 'athletes')
  return (
    <Nav.Link id="OCSMenuAthletes" as={CustomLink} to={urlAthletes}><Label data={label} /></Nav.Link>
  )
}

function ElementMenuBrackets({ active }) {
  const fLabel = useLabels();
  return (
    <>
      <SwiperSlide className="swiperSlide" role="listitem">
        <Dropdown id="OCSMenuBrackets" role='' className={`selectorContainer ${active ? "active" : ""} `}  >
          <Dropdown.Toggle><Label data="LabelBrackets" /></Dropdown.Toggle>
          <Dropdown.Menu role="list" title={fLabel({ data: 'LabelBrackets' })} renderOnMount={true} >
            <EventsItems page={"bracket"} />
          </Dropdown.Menu>
        </Dropdown >
      </SwiperSlide>
    </>
  )
}

function ElementMenuGroups({ active }) {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const fLabel = useLabels();
  let isDisciplinesGroup = ['BDM', 'BKB', 'BKG', 'FBL', 'HBL', 'WPO'].includes(mirs_discipline)
  return (
    <>
      <SwiperSlide className="swiperSlide" role="listitem">
        <Dropdown id="OCSMenuGroups" role='' className={`selectorContainer ${active ? "active" : ""} `} >
          <Dropdown.Toggle>{isDisciplinesGroup ? <Label data="Groups" /> : <Label data="HeaderPools" />}</Dropdown.Toggle>
          <Dropdown.Menu role="list" renderOnMount={true} title={fLabel({ data: 'HeaderPools' })}>
            <EventsItems page={"pool"} />
          </Dropdown.Menu>
        </Dropdown >
      </SwiperSlide>
    </>
  )
}

function SportsItems({ data, page }) {
  let params = useUrlFriendlyToParameters();
  const getURL = useGetURL()
  const getOCSURL = useGetFunctionOCSUrl()
  //Copy object in order to change 
  let paramsURL = { ...params }
  paramsURL["mirs_date"] = ''
  paramsURL["mirs_event"] = ''
  let url


  return (
    <>
      <Dropdown.Item id='OcsSubmenuSportList' key={"Selector-Event-Sport"} eventKey="sports"><Label data={'LabelSports'} /></Dropdown.Item>
      <Dropdown.Divider role="presentation" />
      {Array.isArray(data) && data?.map((item, index) => {
        paramsURL["mirs_discipline"] = item.code
        url = getURL(paramsURL, "schedule")
        url = getOCSURL(url, page, paramsURL)
        return (
          <Dropdown.Item key={"Selector-Discipline-" + item.code} as={listLinks} to={url}    >
            <ItemDiscipline code={item.code} description={item.description} />
          </Dropdown.Item>

        )
      })}
    </>
  )
}

function EventsItems({ discipline, page }) {
  let params = useUrlFriendlyToParameters();
  //Copy object in order to change 
  let paramsURL = { ...params }
  let obj = useGetPath()
  const getURL = useGetURL()
  const getOCSURL = useGetFunctionOCSUrl()
  const dataConfigSport = useGetConfigSports(paramsURL);
  let objUrl = obj(paramsURL.mirs_language);
  if (objUrl.url.isTodayAthMatches || objUrl.url.isTodayMatches || objUrl.url.isTodayTeamMatches) {
    paramsURL["mirs_date"] = ''
  }
  const { mirs_discipline } = params;
  //GET EVENTS
  const data = useGetEvents(params);

  useLayoutEffect(() => {
    let swiperEl = document.querySelector('#OcsSubmenuDisciplineList>a');
    if (swiperEl) {
      swiperEl.removeAttribute("aria-selected", "")
    }
    swiperEl = document.querySelector('#OcsSubmenuSportList');
    if (swiperEl) {
      swiperEl.removeAttribute("aria-selected", "")
    }
  }, [])

  let result = [];
  result = data?.events?.sort((a, b) => a.order - b.order);
  result = result?.filter(event => (event.order !== 0))
  //Remove Division 
  if (mirs_discipline !== 'ATH') {
    result = result?.filter(item => item?.phases?.some(phase => Number(phase.order) > 0));
  }
  //Remove bracket exceptions
  if (page === 'bracket' && dataConfigSport.hasOwnProperty("exceptionBracket")) {
    result = result?.filter(item => !dataConfigSport?.exceptionBracket?.includes(completeRsc(item?.code)))
  }
  let url
  paramsURL["mirs_event"] = ''
  url = getURL(paramsURL, page)
  url = getOCSURL(url, page, paramsURL)
  return (
    <>
      {/* <SwiperSlide className="swiperSlide"> */}

      {discipline && <Dropdown.Item id='OcsSubmenuDisciplineList' key={"Selector-Event-Sport"} as={listLinksNoHandle} to='#' eventKey="sports">{`${discipline}`}</Dropdown.Item>}
      {discipline && <Dropdown.Divider role={"presentation"} />}
      {discipline && <Dropdown.Item key={"Selector-Event-Sport-All"} as={listLinks} to={url} ><Label data={'LabelAllEvents'} /></Dropdown.Item>}
      {Array.isArray(result) && result.map((item, index) => {
        paramsURL["mirs_event"] = item.code
        url = getURL(paramsURL, page)
        url = getOCSURL(url, page, paramsURL)

        return (
          <Dropdown.Item key={"Selector-Event-" + item.code + "_" + index} as={listLinks} to={url} > {/*Change default  element by Link element no use href reload app*/}
            {item.longDescription}
          </Dropdown.Item>
        )
      })}
      {/* </SwiperSlide> */}
    </>
  )
}

//HOC (Higth Order Component) component Link in order to style selected
function CustomLink({ children, id, to, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });
  return (
    <SwiperSlide className={`swiperSlide  ${match ? "active" : ""} `} role="listitem">
      <Link to={to}{...props} >
        {children}
      </Link>
    </SwiperSlide>
  );
}

function listLinks({ children, id, to, ...props }) {
  const handleClick = (e, urlDestination) => {
    if (isSwitchHost()) {
      e.preventDefault()
      window.location.href = urlDestination
    }
  }
  return (
    <div id={id} role="listitem">
      <Link to={to}{...props} onClick={(e) => handleClick(e, to)}>
        {children}
      </Link>
    </div>
  )
}

function listLinksNoHandle({ children, id, to, ...props }) {
  return (
    <div id={id} role="listitem">
      <Link to={to}{...props}>
        {children}
      </Link>
    </div>
  )
}

